import React, { useState, useEffect } from 'react';
//Components 
import { Row, Col, Container, Button } from 'react-bootstrap';
import { RenderIf } from '../utils/RenderIf';
import ErrorAlert from '../Alerts/ErrorAlert';
import SuccessAlert from '../Alerts/SuccessAlert';
import { MachinesFetchAPI } from '../../api/Machines';
import { Modal } from 'react-bootstrap';
import { ListGroup, Card, Form } from 'react-bootstrap';
import Modalbeneficiary from './Modalbeneficiary.jsx';
import ModalimgZoom from '../Modal/ModalimgZoom.jsx';
//PDF
import { PDFViewer, PDFDownloadLink } from '@react-pdf/renderer';
import DocPdf from '../Pdf/DocPdf';
import InvoicePDF from '../Pdf/documents/InvoicePDF.jsx';

//API 
import { ClientsFetchAPI } from '../../api/Clients.jsx';
import { DiscountFetchAPI } from '../../api/Discounts';
import { OrdersFetchAPI } from '../../api/Orders';
import { PrinterFetchAPI } from '../../api/Printer';
import { BranchOfficeFetchAPI } from '../../api/BranchOffices';
import { CategriesPosFetchAPI } from '../../api/Paymentpost/CategoriesPos';
import LoadingAlert from '../Alerts/LoadingAlert';
import { ReturnPayments } from '../utils/ReturnPayments.jsx';
import { PaymentMethodFetchAPI } from '../../api/PaymentMethod.jsx';
import { DeletedTempOrdersFetchAPI } from '../../api/DeletedTemporalOrders';
import { PreOrderFetchAPI } from '../../api/PreOrder';
import { DirectionFetchAPI } from '../../api/Paymentpost/Direction.jsx';
//Utils 
import { formatDateTime } from "../utils/formatDate";
import { buildCloudinaryImageUrl } from '../utils/CloudinaryImageUrl';




import { toast } from "../../utils/toast/toast";



const OrderDetails = ({ pos, orderData, order_type, business_data, setLoad, setModalShow, temporalOrders, setTemporalOrdersData }) => {
    //Variables
    const token = localStorage.getItem('x-access-token');
    let user = localStorage.getItem('user');
    let logo = localStorage.getItem('logoBusiness') !== undefined && localStorage.getItem('logoBusiness') !== null && localStorage.getItem('logoBusiness') !== 'null' && localStorage.getItem('logoBusiness') !== 'undefined' ? localStorage.getItem('logoBusiness') : '';


    //States
    const [edit, setEdit] = useState(false)
    const [extractedText, setExtractedText] = useState({});
    const [extractedTextOriginal, setExtractedTextOriginal] = useState({});
    const [showModalimgZoom, setShowModalimgZoom] = useState(false);
    const [imgpreview, setImgpreview] = useState('')
    const [orderDetailDiscountTotal, setOrderDetailDiscountTotal] = useState(0);
    const [orderDetailGroups, setOrderDetailGroups] = useState([]);
    const [orderDetailCombos, setOrderDetailCombos] = useState([]);
    const [selectDiscount, setSelectDiscount] = useState({})
    const [businessDiscounts, setBusinessDiscounts] = useState([]);
    const [modalShowVoucher, setmodalShowVoucher] = useState(false)
    const [modalCoupon, setModalCoupon] = useState(false)
    const [infoMachine, setInfoMachine] = useState({ machine_name: "" })
    const [eventHandler, setEventHandler] = useState(0);
    const [infoPrinter, setInfoPrinter] = useState({ printer_comanda: "", printer_ticket: "" })
    const [formatVoucher, setformatVoucher] = useState("");
    const [printers, setPrinters] = useState([]);
    const [inputValueCoupon, setInputValueCoupon] = useState(0);
    const [handlerloadData, sethandlerloadData] = useState(0)


    //Grouped taxes
    const groupedTaxes = Object.values(
        orderData.taxes.reduce((acc, item) => {
            if (!acc[item.tax]) {
                acc[item.tax] = { tax: item.tax, total: 0 };
            }
            acc[item.tax].total += item.total;
            return acc;
        }, {})
    )

    //TRAKING DISCOUNT
    const [user_beneficiary, setuser_beneficiary] = useState({ user_id: '', user_name: '' });
    const [client_beneficiary, setclient_beneficiary] = useState({ client_id: '', client_name: '' })
    const [beneficiary, setbeneficiary] = useState('')
    const [datadiscountApply, setDatadiscountApply] = useState({})
    const [dataAddress, setDataAddress] = useState(null)


    let machine = localStorage.getItem('machine');

    //State of the branchoffice 
    const [branchOfficeData, setBranchofficeData] = useState({
        "ruc": "",
        "dv": "",
        "name": "",
        "ruc_type": "",
        "direction": "",
        "dgi_name": "",
    });

    //We get the machine info 
    if (machine !== '' && machine !== undefined && (machine !== null)) {
        machine = JSON.parse(localStorage.getItem('machine'));
    } else {
        machine = {
            id: 0
        }
    }
    //function action print order
    let arrayPrintersTemp = []
    const getPrinter = async () => {
        try {
            const response = await PrinterFetchAPI.getPrinter(localStorage.getItem('x-access-machine-token') === '' ? localStorage.getItem('x-access-token') : localStorage.getItem('x-access-token'), machine.id);

            let arrayPrinters = response.data.printers;
            let printer_Comanda = "";
            let printer_ticket = ""
            for (let i = 0; i < arrayPrinters.length; i++) {
                getCategoriesByprinter(arrayPrinters[i])
                if (arrayPrinters[i].printer_type == 'Tickets') {
                    printer_ticket = arrayPrinters[i].printer_name
                } else if (arrayPrinters[i].printer_type == 'Comanda') {
                    printer_Comanda = arrayPrinters[i].printer_name
                }
            }
            setPrinters(arrayPrintersTemp)
            setInfoPrinter({ printer_comanda: printer_Comanda, printer_ticket: printer_ticket });

        } catch (err) {
            console.log(err);
        }
    }

    //-----------------------------------------------------
    const getCategoriesByprinter = async (printer) => {

        try {
            const response = await CategriesPosFetchAPI.getCategoriesByPrinters(printer.printer_id, localStorage.getItem('x-access-machine-token'))
            printer.categories = response.data.categories

        } catch (err) {
            printer.categories = []
            console.log(err);
        }
        arrayPrintersTemp.push(printer)

    }


    //get client by business 
    const getClientsByBusiness = async () => {
        return new Promise(async (resolve, reject) => {
            try {
                const response = await ClientsFetchAPI.getClientsByBusiness(business_data.id, token);
                resolve(response.data.data);
            } catch (err) {
                console.log(err);
                reject(err);
            }
        });
    }


    const getinfoMachineById = async () => {

        console.log(orderData)
        try {
            const response = await MachinesFetchAPI.getmachineByid(orderData.machine_id, token)
            console.log(response)

            setInfoMachine(response.data.data);
        } catch (err) {
            console.log(err)
        }
    }

    //print order
    const printOrder = async (status) => {
        LoadingAlert()
        let type_ticket = ""
        if (orderData.devolution == true) {
            type_ticket = "Nota a credito"
        } else {
            type_ticket = "factura"
        }

        let arrayPrinters = []
        if (status == true) {
            printers.forEach((printer) => {
                if (printer.printer_type == "Tickets") {
                    arrayPrinters.push(printer)
                }
            });

        } else {
            printers.forEach((printer) => {
                arrayPrinters.push(printer)
            });
        }


        let JsonImprimir = [{
            "type_ticket": type_ticket,
            "Printers": arrayPrinters,
            "Nombre_maquina_impresora": infoPrinter.printer_ticket,
            "Nombre_cocina_impresora": infoPrinter.printer_comanda,
            "Nombre_zebra_impresora": "",
            "Id_Orden_Imprimir": orderData._id,
            "token": localStorage.getItem('x-access-machine-token'),
            "transaction_code": orderData.code,
            "amount_item": orderData.groups.length,
            "imprimir_comanda": "no",
        }]


        try {
            const response_machine = await MachinesFetchAPI.getmachineByid(machine.id, localStorage.getItem('x-access-machine-token'));
            const response = await PrinterFetchAPI.printOrder(JsonImprimir, response_machine.data.data.windows_ip)
            ErrorAlert("La orden se imprimio con exito.", "Orden impresa", "success")
        } catch (err) {
            console.log(err);
            ErrorAlert("La orden no se imprimio con exito.", "Error en la impresion", "error")


            // toast.error({
            //     type: "error",
            //     title: "Error",
            //     message: "La orden no se imprimio con exito. vfrr",
            //     confirmLabel: "Entendido",
            //     cancelLabel: null,
            // });
        }
    }

    const cardGroup = (product, cardGroupDiscount) => {
        return (<>
            <div className="d-flex text-muted pt-2 px-xs-2 border-dashed rounded-3 mt-2 p-2" key={product._id}>
                <img className="bd-placeholder-img flex-shrink-0 me-2 rounded border-dashed" loading="lazy" src={buildCloudinaryImageUrl({ url: product.img, width: 300, quality: "auto", type: "image" })} width="42" height="42" />
                <div className="pb-3 mb-0  lh-sm  w-100">
                    <div className="d-flex justify-content-between ">
                        {/* Name */}
                        <span className="text-black fw-bold">{product.name}</span>
                        {/* Cantidad/ Quantity*/}
                        <div>
                            <span className='px-3 tex-muted opacity-50'>x {product.amount} </span>
                            <label className="fw-bold text-black" translate='no'>$ {product.price.toFixed(2)}</label>
                        </div>

                    </div>
                    {/** Segment items */}
                    <>
                        <div className="d-flex justify-content-between">
                            {/* Name */}

                            <span className=' text-muted opacity-50' >{order_type === "permanent" ? "Descuento" : "Descuento unitario"}</span>
                            {/* Cantidad/ Quantity*/}
                            <div >
                                {/** We check the type of modal and we return the input discount field depending of it */}
                                <RenderIf isTrue={order_type === "permanent" || orderData.is_devolution_notification == true}>
                                    <label className={product.discount === undefined ? "" : " text-black"}>{product.discount === undefined ? "No registrado" : "- $" + product.discount.toFixed(2)}</label>
                                </RenderIf>

                                <RenderIf isTrue={order_type === "temporal" && orderData.is_discount_notification == true && cardGroupDiscount == true}>
                                    <input
                                        type="number"
                                        className='form-control-sm text-danger text-end'
                                        min="0"
                                        step="0.01"
                                        name="product_discount"
                                        data-id={product._id}
                                        placeholder={product.unit_discount === undefined ? 0.00 : product.unit_discount.toFixed(2)}
                                    />
                                </RenderIf>
                            </div>
                        </div>
                        {product.segments.map((segments) => (
                            <div className="d-flex justify-content-between" key={segments._id}>
                                {/* item name */}
                                <span className=' text-muted opacity-50'>{segments.name}</span>
                                <span className=" text-muted opacity-50">{segments.item.name}</span>
                                <span className=" text-black">{parseFloat(segments.item.price).toFixed(2)}</span>
                            </div>
                        ))}

                        <div>
                            <div>
                                <span className='text-secondary opacity-50' >
                                    Entrega: {product.delivery_type}
                                </span>
                            </div>
                            <div>
                                <RenderIf isTrue={product.note != ""}>
                                    <span className='text-danger p-1' >
                                        Nota: {product.note}
                                    </span>
                                </RenderIf>
                            </div>


                        </div>

                    </>
                </div>
            </div>
        </>)
    }


    //We charge the items of the order 
    const orderItems = () => {
        let items = orderDetailGroups.map((product) => (
            <>{cardGroup(product, true)}</>
        ));
        return <>{items}</>
    }

    //We charge the items of the order 
    const orderCombos = () => {
        let items = orderDetailCombos.map((combo) => (
            <div className="d-flex text-muted pt-3 px-xs-2  border-dashed" key={combo.combo_id}>
                <img className="bd-placeholder-img flex-shrink-0 me-2 rounded-2 border border-dashed" src={combo.img} width="42" height="42" />
                <div className="pb-3 mb-0  lh-sm  w-100">
                    <div className="d-flex justify-content-between ">
                        {/* Name */}
                        <span className="text-dark fw-bold">{combo.name}</span>
                        {/* Cantidad/ Quantity*/}
                        <div>
                            <span className='px-3'>x {combo.amount} </span>
                            <label className="fw-bold" translate='no'>$ {combo.price.toFixed(2)}</label>
                        </div>

                    </div>
                    {/** Segment items */}
                    <>
                        <div className="d-flex justify-content-between">
                            {/* Name */}

                            <span >{order_type === "permanent" ? "Descuento" : "Descuento unitario"}</span>
                            {/* Cantidad/ Quantity*/}
                            <div >
                                {/** We check the type of modal and we return the input discount field depending of it */}
                                <RenderIf isTrue={order_type === "permanent" || orderData.is_devolution_notification == true}>
                                    <label className={combo.discount === undefined ? "" : "text-danger"}>{combo.discount === undefined ? "No registrado" : "- $" + combo.discount.toFixed(2)}</label>
                                </RenderIf>

                                <RenderIf isTrue={order_type === "temporal" && orderData.is_discount_notification == true}>
                                    <input
                                        type="number"
                                        className='form-control-sm text-danger text-end'
                                        min="0"
                                        step="0.01"
                                        name="combo_discount"
                                        data-id={combo.combo_id}
                                        placeholder={combo.unit_discount === undefined ? 0.00 : combo.unit_discount.toFixed(2)}
                                    />
                                </RenderIf>
                            </div>
                        </div>
                        {combo.setGroups.map((setGroup) => (

                            <div className="d-flex justify-content-between" key={setGroup.set_id}>
                                <details close >
                                    <summary className=''>
                                        <span className='badge bg-light text-dark summary-text-pos  fw-bold border rounded-4  text-wrap m-1 '>
                                            <i className="uil uil-info-circle  px-1 "> {setGroup.name}</i>
                                        </span>
                                    </summary>
                                    {setGroup.groups.map((group) => (<>
                                        {cardGroup(group)}
                                    </>))}
                                </details>
                            </div>
                        ))}
                        <div>
                            <div>
                                <small className='text-primary p-1' >
                                    Entrega: {combo.delivery_type}
                                </small>
                            </div>
                            <div>
                                <RenderIf isTrue={combo.note != ""}>
                                    <small className='text-danger p-1' >
                                        Nota: {combo.note}
                                    </small>
                                </RenderIf>
                            </div>
                        </div>
                    </>
                </div>
            </div>
        ));
        return <>{items}</>
    }

    //We charge the select discounts 
    const discountsOptions = () => {
        let discounts = businessDiscounts.map((discount) => (
            <option key={discount.discount_id} value={JSON.stringify(discount)}>{discount.discount_name}</option>
        ));
        return discounts
    }

    //Function to calculate the rouding of a discount
    const rounding = (amount_discount) => {

        let result = (amount_discount / 0.05).toFixed(2);
        //We verify if the result is int or decimal 
        if (result % 1 == 0) {
            console.log('no es decimal')
            amount_discount = parseFloat(amount_discount);
        } else {
            console.log('es decimal');
            amount_discount = parseFloat(amount_discount) + 0.01;
            rounding(amount_discount)
        }
        return amount_discount
    }


    //decimal reduction
    const decimalReduction = (value) => {
        let stringTax = mathRound(value).toString()
        let arraySteingTax = stringTax.split(".");
        let newDecimalTaxString = []
        let sampleTax = ''
        if (arraySteingTax[1] != undefined) {
            newDecimalTaxString = arraySteingTax[1].slice(0, 2);
            sampleTax = arraySteingTax[0] + "." + newDecimalTaxString
            console.log("Hice la reduccion");
        } else {
            console.log("Array: " + arraySteingTax);
            console.log("Decimal: " + newDecimalTaxString);
            console.log("Nuevo valor: " + sampleTax);
            sampleTax = stringTax;
        }

        let endValue = parseFloat(sampleTax).toFixed(2)
        return endValue
    }

    function mathRound(num) {
        //Respuesta de Rubén
        return Math.round(num * 100) / 100;
    }

    //Function to calculate the discounts 
    const calculateDiscounts = (jsondiscount) => {
        let json = JSON.parse(jsondiscount);
        setSelectDiscount(json.type);
        let discount = json.discountRate
        //We get the discount rate 
        let discount_rate = discount / 100;
        let totaldiscounts = 0;
        const discounts = document.getElementsByName('product_discount');
        const discountscombos = document.getElementsByName('combo_discount');
        let arrayGroupId = []
        //For every group we calculate the discount of it 
        for (let i = 0; i < orderDetailGroups.length; i++) {
            arrayGroupId.push({ group_id: orderDetailGroups[i].group_id })
            //We clear the input of the discount 
            discounts[i].value = ""
            //We get the group info 
            let group_info = orderDetailGroups[i];
            //let unit_discount = decimalReduction((group_info.price * discount_rate));
            //let total_product_discount = decimalReduction(((group_info.price * discount_rate) * group_info.amount))
            let unit_discount = decimalReduction(group_info.price * discount_rate);
            let total_product_discount = decimalReduction((group_info.price * discount_rate) * group_info.amount)
            orderDetailGroups[i].unit_discount = parseFloat(unit_discount)  //rounding(unit_discount);
            totaldiscounts = totaldiscounts + parseFloat(total_product_discount) //rounding(total_product_discount);
        }

        let arrayCombosId = []
        //For every group we calculate the discount of it 
        for (let i = 0; i < orderDetailCombos.length; i++) {
            arrayCombosId.push({ combo_id: orderDetailCombos[i].combo_id })
            //We clear the input of the discount 
            discountscombos[i].value = ""
            //We get the group info 
            let combo_info = orderDetailCombos[i];
            //let unit_discount = decimalReduction((group_info.price * discount_rate));
            //let total_product_discount = decimalReduction(((group_info.price * discount_rate) * group_info.amount))
            let unit_discount = decimalReduction(combo_info.price * discount_rate);
            let total_product_discount = decimalReduction((combo_info.price * discount_rate) * combo_info.amount)
            orderDetailCombos[i].unit_discount = parseFloat(unit_discount)  //rounding(unit_discount);
            totaldiscounts = totaldiscounts + parseFloat(total_product_discount) //rounding(total_product_discount);
        }
        let dataUser = JSON.parse(user)
        let dataDiscount = {
            "name": json.discount_name,
            "discount_id": json.discount_id,
            "total": totaldiscounts,
            "percentage": json.discountRate + "%",
            "groups": arrayGroupId,
            "combos": arrayCombosId,
            "beneficiary": {
                "client_id": client_beneficiary.client_id,
                "client_name": client_beneficiary.client_name,
                "user_id": user_beneficiary.user_id,
                "user_name": user_beneficiary.user_name
            },
            "aprrovedby": {
                "user_id": dataUser.id,
                "user_name": dataUser.name
            }
        }

        setDatadiscountApply(dataDiscount)

        //We set the total discount of the order 
        orderData.discount = totaldiscounts;
        //We set the new order group detail info 
        setOrderDetailGroups(orderDetailGroups)
        setOrderDetailCombos(orderDetailCombos)
        //We set the total discount detail 
        setOrderDetailDiscountTotal(totaldiscounts);
        //We force the recharge of the component
        setEventHandler(1);
    }

    //Function to calculate the cupon 
    const calculateCupon = () => {

        let discount_rate = parseInt(inputValueCoupon);
        let totaldiscounts = 0;
        const discounts = document.getElementsByName('product_discount');
        const discountscombo = document.getElementsByName('combo_discount');
        setSelectDiscount("C");
        //For every group we calculate the discount of it 
        for (let i = 0; i < orderDetailGroups.length; i++) {
            //We clear the input of the discount 
            discounts[i].value = ""
            calculateDiscountByGroupAndCombo(orderDetailGroups[i], i, false)
        }

        for (let i = 0; i < orderDetailCombos.length; i++) {
            //We clear the input of the discount 
            discountscombo[i].value = ""
            calculateDiscountByGroupAndCombo(orderDetailCombos[i], i, true)
        }

        function calculateDiscountByGroupAndCombo(item, index, combo) {
            let total_product_discount = (item.price * item.amount).toFixed(2);
            //Verify that the discount values ​​are greater than the total value of the quantity of products
            if (discount_rate >= total_product_discount) {
                //equalizes the value of the product to its unit discount
                let unit_discount = item.price
                total_product_discount = (item.price * item.amount).toFixed(2);

                if (combo == true) {
                    orderDetailCombos[index].unit_discount = parseFloat(unit_discount)
                } else {
                    orderDetailGroups[index].unit_discount = parseFloat(unit_discount)  //rounding(unit_discount);
                }

                totaldiscounts = totaldiscounts + parseFloat(total_product_discount) //rounding(total_product_discount);
                //deducts the balance from the value of the discount applied
                discount_rate = (discount_rate - total_product_discount)
            } else {
                //Divide the discount by the quantity of the items in the group
                let unit_discount = (discount_rate / item.amount).toFixed(2);

                if (unit_discount >= 0) {// validates that the unit discount is not negative
                    total_product_discount = (unit_discount * item.amount).toFixed(2);
                    totaldiscounts = totaldiscounts + parseFloat(total_product_discount) //rounding(total_product_discount);

                    if (totaldiscounts > parseInt(inputValueCoupon)) {// validate that the value of the discount is not greater than the value of the coupon
                        let diference_unit = ((totaldiscounts - parseInt(inputValueCoupon)) / item.amount) //calculate the difference between the discount and the coupon applied
                        unit_discount = (unit_discount - diference_unit) //calculates the adjusted unit discount
                        total_product_discount = (unit_discount * item.amount) //recalculates the value of the total product discount by the quantity
                        totaldiscounts = totaldiscounts - (totaldiscounts - parseInt(inputValueCoupon)) // readjusts the total discount applied
                        console.log(diference_unit);
                    }

                    console.log(unit_discount);
                    console.log(totaldiscounts);

                    if (combo == true) {
                        orderDetailCombos[index].unit_discount = parseFloat(unit_discount)
                    } else {
                        orderDetailGroups[index].unit_discount = parseFloat(unit_discount)  //rounding(unit_discount);
                    }

                    discount_rate = (discount_rate - total_product_discount);
                }
            }
        }

        //We set the total discount of the order 
        orderData.discount = totaldiscounts;
        //We set the new order group detail info 
        setOrderDetailGroups(orderDetailGroups)
        setOrderDetailCombos(orderDetailCombos)
        //We set the total discount detail 
        setOrderDetailDiscountTotal(totaldiscounts);
        //We force the recharge of the component
        setEventHandler(1);
        setModalCoupon(false)

        console.log(orderDetailGroups, "ORDEN NOW");
    }

    //We update the discount 
    const updateOrderDiscount = async () => {
        if (datadiscountApply.beneficiary) {
            datadiscountApply.beneficiary.client_id = client_beneficiary.client_id
            datadiscountApply.beneficiary.client_name = client_beneficiary.client_name
            datadiscountApply.beneficiary.user_id = user_beneficiary.user_id
            datadiscountApply.beneficiary.user_name = user_beneficiary.user_name

            setDatadiscountApply(datadiscountApply)
        }

        const discounts = document.getElementsByName('product_discount');
        const discountscombo = document.getElementsByName('combo_discount');
        let totaldiscounts = 0;


        //We update the status of the temp order 
        orderData.status_id = 9

        if (orderData.is_discount_notification == true) {
            let discount_empty = false

            //We get the discounts of the products 
            for (let i = 0; i < orderData.groups.length; i++) {
                let product_discount = discounts[i].value !== "" ? discounts[i].value : discounts[i].getAttribute('placeholder')

                console.log(selectDiscount);
                //We check if the discount is 0

                if (selectDiscount != "%") {

                    if (product_discount === 0 || product_discount === '0.00' || product_discount === '0') {
                        if (selectDiscount != "C") {
                            discount_empty = true
                        }
                    }
                } else {
                    orderData.groups[i].taxtValue = 0;
                    orderData.groups[i].tax = "0%";
                }

                //validates that the product discount is not greater than the price
                if (product_discount > orderData.groups[i].price) {
                    totaldiscounts = totaldiscounts + parseFloat(orderData.groups[i].price * orderData.groups[i].amount);
                    orderData.groups[i].unit_discount = parseFloat(orderData.groups[i].price);
                    orderData.groups[i].discount = parseFloat(orderData.groups[i].price);
                } else {
                    totaldiscounts = totaldiscounts + parseFloat(product_discount * orderData.groups[i].amount);
                    orderData.groups[i].unit_discount = parseFloat(product_discount);
                    orderData.groups[i].discount = parseFloat(product_discount * orderData.groups[i].amount);
                }
            }

            for (let i = 0; i < orderData.combos.length; i++) {
                let product_discount = discountscombo[i].value !== "" ? discountscombo[i].value : discountscombo[i].getAttribute('placeholder')
                let combo = orderData.combos[i]
                console.log(selectDiscount);
                //We check if the discount is 0

                if (selectDiscount != "%") {

                    if (product_discount === 0 || product_discount === '0.00' || product_discount === '0') {
                        if (selectDiscount != "C") {
                            discount_empty = true
                        }
                    }
                } else {
                    combo.taxtValue = 0;
                    combo.tax = "0%";
                }

                //validates that the product discount is not greater than the price
                if (product_discount > combo.price) {
                    totaldiscounts = totaldiscounts + parseFloat(combo.price * combo.amount);
                    combo.unit_discount = parseFloat(combo.price);
                    combo.discount = parseFloat(combo.price);
                } else {
                    totaldiscounts = totaldiscounts + parseFloat(product_discount * combo.amount);
                    combo.unit_discount = parseFloat(product_discount);
                    combo.discount = parseFloat(product_discount * combo.amount);
                }
            }
            //We set the total discount of the order 
            orderData.discount = totaldiscounts;
            //We set the total discount detail 
            setOrderDetailDiscountTotal(totaldiscounts);

            if (discount_empty === true) {
                ErrorAlert('No puede haber descuentos en 0', 'Error', 'warning')
            } else {

                let arrayDiscount = []
                if (orderData.discounts) {
                    arrayDiscount = orderData.discounts
                    arrayDiscount.push(datadiscountApply)
                } else {
                    arrayDiscount.push(datadiscountApply)
                }
                try {
                    //We update the temporal order
                    await OrdersFetchAPI.updateTempOrder(
                        {
                            "_id": orderData._id,
                            "status_id": orderData.status_id,
                            "groups": orderData.groups,
                            "combos": orderData.combos,
                            "discount": orderData.discount,
                            'discounts': arrayDiscount
                        },
                        token
                    );
                } catch (err) {
                    ErrorAlert(err.error)
                }
                //We close the modal 
                setModalShow(false)
                //We find the order on the temporal orders data 
                let index = temporalOrders.findIndex(order => order._id === orderData._id);
                //We delete the order updated 
                temporalOrders.splice(index, 1);
                //We set the temporal orders with the data updated 
                setTemporalOrdersData(temporalOrders);
                //We set the reload state to reload the component 
                setLoad(1)
            }
        } else {
            try {
                let dataUser = JSON.parse(user)
                //We update the temporal order
                await OrdersFetchAPI.updateTempOrder(
                    {

                        "_id": orderData._id,
                        "status_id": orderData.status_id,
                        "groups": orderData.groups,
                        "combos": orderData.combos,
                        "discount": orderData.discount,
                        "approved_by": {
                            "code": dataUser.user_code,
                            "name": dataUser.name
                        }
                    },
                    token
                );
            } catch (err) {
                ErrorAlert(err.error)
            }
            //We close the modal 
            setModalShow(false)
            //We find the order on the temporal orders data 
            let index = temporalOrders.findIndex(order => order._id === orderData._id);
            //We delete the order updated 
            temporalOrders.splice(index, 1);
            //We set the temporal orders with the data updated 
            setTemporalOrdersData(temporalOrders);
            //We set the reload state to reload the component 
            setLoad(1)
        }
    }

    //update temporal autorization
    const updatePreOrder = async () => {
        try {
            //We update the temporal order
            await OrdersFetchAPI.updateTempOrder(
                {

                    "_id": orderData._id,
                    "status_id": orderData.status_id,
                    "groups": orderData.groups,
                    "is_authorized": true,
                    "is_discount_notification": false,
                    "is_pre_order": true,
                    "combos": orderData.combos,
                    "discount": orderData.discount
                },
                token
            );
        } catch (err) {
            ErrorAlert(err.error)
        }
        //We close the modal 
        setModalShow(false)
        //We find the order on the temporal orders data 
        let index = temporalOrders.findIndex(order => order._id === orderData._id);
        //We delete the order updated 
        temporalOrders.splice(index, 1);
        //We set the temporal orders with the data updated 
        setTemporalOrdersData(temporalOrders);
        //We set the reload state to reload the component 
        setLoad(1)
    }

    //delete preorder
    const deletePreOrder = async () => {
        LoadingAlert()

        let jsonUpdate = {
            "order_code": orderData.code,
            "business_code": orderData.business.code,
            "branchoffice_code": orderData.branchoffice.code,
            "deleted": true,
            "status": 5,
            "user_id": 0
        }
        try {
            //We save the preorder
            await DeletedTempOrdersFetchAPI.newDeletedTempOrder(jsonUpdate, token);
            //We delete the preorder
            await PreOrderFetchAPI.deletePreOrder(jsonUpdate, token)
            let message = "precuenta eliminada con exito."
            let title = "Precuenta eliminada"
            let icon = "success"
            ErrorAlert(message, title, icon)

        } catch (err) {
            console.log(err);
        }
    }


    //We cancel the order discount 
    const cancelOrderDisocunt = async () => {
        //We update the status of the temp order (of cancel)
        orderData.status_id = 8
        try {
            //We update the temporal order
            await OrdersFetchAPI.updateTempOrder(
                {
                    "_id": orderData._id,
                    "status_id": orderData.status_id
                },
                token
            );
            //Alert message 
            SuccessAlert("Descuento cancelado")
        } catch (err) {
            ErrorAlert(err.error)
            console.log(err)
        }
        //We close the modal 
        setModalShow(false);
        //We find the order on the temporal orders data 
        let index = temporalOrders.findIndex(order => order._id === orderData._id);
        //We delete the order updated 
        temporalOrders.splice(index, 1);
        //We set the temporal orders with the data updated 
        setTemporalOrdersData(temporalOrders);
        //We set the reload state to reload the component 
        setLoad(1)
    }

    const hasVoucher = (v) => !!v && v !== "0"

    // Pagos mixtos: el voucher de cada pago vive en paymethods[].voucher_response (JSON string o texto plano)
    const paymethodVoucherText = (pm) => {
        const raw = hasVoucher(pm.bank_voucher_response) ? pm.bank_voucher_response : pm.voucher_response
        if (!hasVoucher(raw)) return ""
        try {
            const parsed = JSON.parse(raw)
            if (parsed && typeof parsed === "object") return parsed.voucher ? String(parsed.voucher) : raw
            return String(raw)
        } catch (err) { return raw }
    }

    const paymethodVouchers = (orderData.paymethods || [])
        .map((pm) => ({ name: pm.name, total: pm.total, text: paymethodVoucherText(pm) }))
        .filter((p) => p.text)

    // funtion convert format voucher
    const formatVoucherString = () => {
        console.log("DATA DEL VOUCHER");
        let kinposVoucher = null
        if (orderData.bank_voucher_response) {
            try {
                let dataVoucher = JSON.parse(orderData.bank_voucher_response)
                if (dataVoucher.Auth_Code) {
                    setExtractedText(dataVoucher)
                    setExtractedTextOriginal(dataVoucher)
                    setImgpreview(dataVoucher.imgUrl)
                } else if (dataVoucher.voucher) {
                    kinposVoucher = dataVoucher.voucher
                }
            } catch (err) { console.log(err) }
        }

        const blocks = []
        const rootVoucher = kinposVoucher || (hasVoucher(orderData.voucher_response) ? orderData.voucher_response : "")
        if (rootVoucher) blocks.push(rootVoucher)
        paymethodVouchers.forEach((p) => blocks.push(`${p.name}${p.total != null ? ` - $${Number(p.total).toFixed(2)}` : ""}\n${p.text}`))
        const voucher = blocks.join("\n\n----------------------------------------\n\n")
        // Extraer el número de tarjeta ocultando los dígitos intermedios
        const maskedVoucher = voucher.replace(/(\d{6})\d+(\d{4})/g, "$1XXXXXX$2");

        // Construir el string formateado del voucher
        const formattedVoucher = `${maskedVoucher}`;
        setformatVoucher(formattedVoucher)


        //return formattedVoucher;
    };

    const handleViewCoucher = () => {
        formatVoucherString()
        setmodalShowVoucher(true)
    }



    //update voucher
    const updateVoucher = async () => {
        let data = {
            "bank_voucher": JSON.stringify(extractedText),
        }

        try {
            const response = await OrdersFetchAPI.updateVoucher(orderData._id, data, token)
            console.log(response);
            setEdit(false)
            //setModalShow(false)
            ErrorAlert("", "Data actualizada con exito", "success")
        } catch (err) {
            ErrorAlert("", err.error, "error")
        }
    }

    //Function to make the evertech return 
    const ecommerceReturnPayment = async () => {

        try {
            let secretKey, loginKey, paymentMethodIndex, cclw, pagueloFacilAuthToken, returnType;
            //We use the loading alert 
            LoadingAlert('Procesando...', 'Por favor espere...')
            //We get the machine payment methods
            let paymentMethods = await PaymentMethodFetchAPI.getPaymentMethod(orderData.machine_id, token);

            //We check the payment type 
            if (orderData.paymenthod === "Evertech") {
                //We get the evertech params 
                paymentMethodIndex = paymentMethods.data.data.findIndex(element => element.payment === "Evertech");
                returnType = "Evertech"
            } else if (orderData.paymenthod === "PagueloFacil") {
                //We get the evertech params 
                paymentMethodIndex = paymentMethods.data.data.findIndex(element => element.payment === "PagueloFacil");
                returnType = "PagueloFacil"
            }
            //We check that the payment method exist 
            if (paymentMethodIndex !== -1) {
                //We map the variables to asing every param value 
                paymentMethods.data.data[paymentMethodIndex].params.forEach(param => {
                    switch (param.name) {
                        case "SECRET_KEY":
                            secretKey = param.value;
                            break;
                        case "LOGIN_KEY":
                            loginKey = param.value;
                            break;
                        case "CCLW":
                            cclw = param.value;
                        case "PAGUELOFACIL_AUTH_TOKEN":
                            pagueloFacilAuthToken = param.value
                        default:
                            break;
                    }
                });
                //We make the return 
                ReturnPayments({
                    secretKey,
                    loginKey,
                    paymentEvertechInternalReference: orderData.evertech_payment_reference,
                    total: orderData.total,
                    token,
                    transaction_code: orderData.transaction_code,
                    business_code: orderData.business.code,
                    branchoffice_code: orderData.branchoffice.code,
                    bank_voucher_response: { EMVStreamResponse: orderData.bank_voucher_response },
                    setLoad: setLoad,
                    cclw,
                    codOper: orderData.paguelofacil_oper_code,
                    pagueloFacilAuthToken,
                    returnType
                });
            } else {
                ErrorAlert('Metodo de pago no asignado a la maquina de esta transaccion', 'Metodo de pago no encontrado', 'warning');
            }

        } catch (err) {
            console.log(err)
        }
    }

    //Hook to load the business discounts 
    useEffect(() => {
        (async () => {
            try {
                //We get the discounts 
                const discounts = await DiscountFetchAPI.getDiscountsByBusiness(business_data.id, token);
                setBusinessDiscounts(discounts.data.data);
            } catch (err) {
                setBusinessDiscounts([])
                console.log(err);
            }

            try {
                //We get the branchoffice info 
                const response_branch = await BranchOfficeFetchAPI.getBranchOfficeByCode(orderData.business.code, orderData.branchoffice.code);
                console.log("Detalle de la sucursal: ", response_branch.data.branchoffice);
                //We set the business data 
                setBranchofficeData(response_branch.data.branchoffice);

            } catch (err) {
                setBranchofficeData({
                    "ruc": "",
                    "dv": "",
                    "name": "",
                    "ruc_type": "",
                    "direction": "",
                    "dgi_name": "",
                })
            }
        })();
    }, []);

    const getDirestionByid = async () => {
        if (orderData.direction.id == "0") {


            let data = { "name": "--", "house_num": "--", "additional_info": "--", "phone": orderData.client_phone, "lat": orderData.direction.lat, "lng": orderData.direction.lng };
            setDataAddress(data)

        } else {
            try {
                const response = await DirectionFetchAPI.getDirectionById(orderData.direction.id, token);
                console.log("Detalle de la direccion: ", response.data.direction);
                setDataAddress(response.data.direction)
            } catch (err) {
                console.log(err);
            }
        }

    }

    //Hook to reload the component 
    useEffect(() => {
        getPrinter()
        if (orderData.direction) {
            if (orderData.direction.id) {
                getDirestionByid()
            }
        }
        setOrderDetailGroups(orderData.groups);
        setOrderDetailCombos(orderData.combos);
        setOrderDetailDiscountTotal(orderData.discount)
        getinfoMachineById()
        setEventHandler(0);
    }, [eventHandler]);


    useEffect(() => {
        sethandlerloadData(0)
    }, [handlerloadData]);

    return (

        <>
            <div className='position-relative'>

                <div className='position-absolute top-0 start-100 translate-middle mt-2 '>
                    <div className='me-3'>
                        <button class="btn btn-outline-secondary border-0 bg-light text-secondary rounded-circle p-2 lh-1" type="button" title='Cerrar'
                            onClick={() => setModalShow(false)}>
                            <i class="uil uil-multiply"></i>
                        </button>
                    </div>
                </div>

                <h2 className="title-main-login  text-center ">
                    <i class="uil uil-receipt-alt" translate='no'></i>
                    Detalles de Transacción xxx
                </h2>

                {/* Your card */}
                <div className="py-1 border border-light">
                    <div className="head-section-sp">
                        <div className="mt-1 mb-3">
                            <div className=' d-flex justify-content-between'>
                                <span className='text-primary fw-semibold'> Acciones </span>
                            </div>
                            <div className=' d-inline  gap-2'>
                                <Modal
                                    show={modalShowVoucher}
                                    onHide={() => setmodalShowVoucher(false)}
                                    centered>
                                    <Modal.Header>
                                        Voucher de transaccion: #{orderData.transaction_code}
                                    </Modal.Header>
                                    <Modal.Body>
                                        {imgpreview != "" ? <>
                                            <div className="d-flex justify-content-center align-items-center vh-100">
                                                {/*----------------------------------Secction description------------------------------------------- */}
                                                <Card className='m-2 '>
                                                    <Card.Body>
                                                        <Card.Title>
                                                            <section className='px-1'>
                                                                <div className='d-flex justify-content-center display-title border-inset border-pos rounded-3 mb-1'>
                                                                    <span className='m-3'> <i class="uil uil-file-info-alt"> Detalle del voucher</i></span>
                                                                </div>
                                                            </section>
                                                        </Card.Title>
                                                        <Card.Text>
                                                            <div className='d-flex align-item-center justify-content-center mb-2' onClick={() => setShowModalimgZoom(true)} >
                                                                <img
                                                                    className='imgOcr'
                                                                    src={extractedText.imgUrl}
                                                                />
                                                            </div>
                                                            Informacion del voucher.
                                                            <Container>
                                                                <Row>
                                                                    <Col>

                                                                        <div className='mt-3 '>
                                                                            <ListGroup.Item
                                                                                as="li"
                                                                                className="d-flex justify-content-center alight-item-center "
                                                                            >

                                                                                '

                                                                                {edit == false ? <>
                                                                                    <button type="button" className='btn btn-outline-primary pulse rounded-3 p-2 lh-1 border m-1'
                                                                                        onClick={() => setEdit(true)}
                                                                                    ><i class="uil uil-edit"> Editar</i>
                                                                                    </button></> : <>
                                                                                    <button type="button" className='btn btn-outline-danger pulse rounded-3 p-2 lh-1 border m-1'
                                                                                        onClick={() => (setEdit(false), setExtractedText(extractedTextOriginal))}
                                                                                    ><i class="uil uil-times-circle"> Cancelar edicion</i>
                                                                                    </button>


                                                                                    <button type="button" className='btn btn-outline-primary pulse rounded-3 p-2 lh-1 border m-1'
                                                                                        onClick={() => updateVoucher()}
                                                                                    ><i class="uil uil-save"> Guardar cambios</i>
                                                                                    </button></>}





                                                                            </ListGroup.Item>
                                                                        </div>

                                                                        <RenderIf isTrue={extractedText.Payment_Method}>
                                                                            <div className='mt-3 '>
                                                                                <ListGroup as="ol" >
                                                                                    <ListGroup.Item
                                                                                        as="li"
                                                                                        className="d-flex justify-content-center align-items-start m-0 p-0"
                                                                                    >


                                                                                        <div className="ms-2 me-auto">
                                                                                            <div className="fw-bold">Metodo de pago</div>
                                                                                            {extractedText.Payment_Method}
                                                                                        </div>

                                                                                    </ListGroup.Item>
                                                                                </ListGroup>
                                                                            </div>
                                                                        </RenderIf>
                                                                        <RenderIf isTrue={extractedText.Auth_Code}>
                                                                            <div className='mt-3 '>
                                                                                <ListGroup as="ol" >
                                                                                    <ListGroup.Item
                                                                                        as="li"
                                                                                        className="d-flex justify-content-center align-items-start m-0 p-0"
                                                                                    >
                                                                                        {edit == false ? <>
                                                                                            <div className="ms-2 me-auto">
                                                                                                <div className="fw-bold">Autorizacion</div>
                                                                                                {extractedText.Auth_Code}
                                                                                            </div>
                                                                                        </> : <div className="ms-2 me-auto">   <Form.Group className="mb-3" controlId="Auth_Code">
                                                                                            <Form.Label>Autorizacion</Form.Label>
                                                                                            <Form.Control
                                                                                                type="text"
                                                                                                placeholder={extractedText.Auth_Code}
                                                                                                name="Auth_Code"
                                                                                                onChange={(e) => setExtractedText({ ...extractedText, Auth_Code: e.target.value })}
                                                                                            />
                                                                                        </Form.Group></div>}
                                                                                    </ListGroup.Item>
                                                                                </ListGroup>
                                                                            </div>
                                                                        </RenderIf>
                                                                        <RenderIf isTrue={extractedText.Total}>
                                                                            <div className='mt-3 '>
                                                                                <ListGroup as="ol" >
                                                                                    <ListGroup.Item
                                                                                        as="li"
                                                                                        className="d-flex justify-content-center align-items-start m-0 p-0"
                                                                                    >
                                                                                        {edit == false ? <>
                                                                                            <div className="ms-2 me-auto">
                                                                                                <div className="fw-bold">Total:</div>
                                                                                                {extractedText.Total}
                                                                                            </div>
                                                                                        </> : <div className="ms-2 me-auto">   <Form.Group className="mb-3" controlId="Total">
                                                                                            <Form.Label>Total</Form.Label>
                                                                                            <Form.Control
                                                                                                type="text"
                                                                                                placeholder={extractedText.Total}
                                                                                                name="Total"
                                                                                                onChange={(e) => setExtractedText({ ...extractedText, Total: e.target.value })}
                                                                                            />
                                                                                        </Form.Group></div>}
                                                                                    </ListGroup.Item>
                                                                                </ListGroup>
                                                                            </div></RenderIf>

                                                                        <RenderIf isTrue={extractedText.text}>
                                                                            <div className='mt-3 '>

                                                                                <div className="ms-2 me-auto">
                                                                                    <div className="fw-bold">Decripcion:</div>
                                                                                    <p >{extractedText.text}</p>
                                                                                </div>
                                                                            </div>
                                                                        </RenderIf>
                                                                    </Col>
                                                                </Row>
                                                            </Container>
                                                        </Card.Text>
                                                    </Card.Body>
                                                </Card>
                                            </div>
                                        </> : <> <div className='d-flex alight-item-center justify-content-center'>
                                            <div>
                                                <pre>{formatVoucher}</pre>
                                            </div>
                                        </div></>}

                                    </Modal.Body>
                                    <Modal.Footer>
                                        <Button onClick={() => (setmodalShowVoucher(false))}>Cerrar</Button>
                                    </Modal.Footer>
                                </Modal>

                                {/**Print button  */}
                                <RenderIf isTrue={order_type === "permanent"}>
                                    <RenderIf isTrue={pos == true}>
                                        <button className='m-2' onClick={() => (printOrder(true))}><i className="uil uil-print m-1"></i> Imprimir solo factura</button>
                                        <vutton className='m-2' onClick={() => (printOrder(false))}><i className="uil uil-print m-1"></i> Imprimir factura con comanda</vutton>
                                    </RenderIf>
                                </RenderIf>

                                {/**Voucher button */}
                                <RenderIf isTrue={(orderData.bank_voucher_response != "0" || paymethodVouchers.length > 0) && order_type === "permanent"}>

                                    <button class="btn bg-primary-subtle rounded-2 border-primary text-primary fw-bold"
                                        onClick={() => (handleViewCoucher())} title="Actualizar Lista">
                                        <i className="uil uil-receipt-alt "></i>
                                        Voucher de transacción

                                    </button>
                                </RenderIf>


                                <RenderIf isTrue={order_type === "permanent"}>
                                    <PDFDownloadLink document={
                                        <InvoicePDF
                                            data={{
                                                emisor: orderData.branchoffice.fiscal_name,
                                                emisorRuc: orderData.branchoffice.ruc,
                                                emisorDv: orderData.branchoffice.dv,
                                                emisorDireccion: branchOfficeData.direction,
                                                clienteNombre: orderData.client_name,
                                                clienteRuc: orderData.client_ruc,
                                                clienteDv: orderData.client_dv,
                                                clienteDireccion: orderData.client_address,
                                                clienteTelefono: orderData.client_phone,
                                                fechaEmision: orderData.createdAt ? new Date(orderData.createdAt).toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit', year: 'numeric' }) : '',
                                                puntoFacturacion: infoMachine.code,
                                                consultaClaveUrl: orderData.dgi_qr,
                                                cufe: orderData.cufe,
                                                transaction_code: orderData.transaction_code,
                                                order_id: orderData.order_id,
                                                machine_code_order_id: orderData.machine_code_order_id,
                                                items: orderData.groups,
                                                itbmsBreakdown: orderData.taxes,
                                                metodoPago: "",
                                                formaPagoMonto: "",
                                                totalPagado: orderData.total,
                                                tips: orderData.tips,
                                                subtotal: orderData.subtotal,
                                                discount: orderData.discount,
                                                tax: orderData.tax,
                                                total: orderData.total,
                                                typeDocument: orderData.order_type === "devolution" ? "credit_note" : "invoice",
                                                logo: logo,
                                                aditional_info: orderData.aditional_info ? orderData.aditional_info : "",
                                                delivery: orderData.delivery ? orderData.delivery : { value: 0 },


                                            }} />
                                    }>
                                        <button className=' btn bg-primary-subtle rounded-2 border-primary text-primary fw-bold' > {orderData.invoice_type === "devolution" ? "Descargar nota de credito" : "Descargar factura electronica"} </button>
                                    </PDFDownloadLink>
                                </RenderIf>

                                {/** Devolution button */}
                                <RenderIf isTrue={orderData.paymenthod_integration_id === 5 && orderData.devolution === false && orderData.order_type !== "devolution"}>
                                    <button className=' btn bg-danger-subtle rounded-2 border-danger text-danger fw-bold' onClick={() => ecommerceReturnPayment()} variant="danger"><i className="uil  uil-exchange-alt"></i>
                                        {/* Realizar devolucion de pasarela de pago */}
                                        <span className='ms-2'>Devolver pago</span>
                                    </button>
                                </RenderIf>
                                <Modal
                                    show={modalCoupon}
                                    size="md"
                                    onHide={() => setModalCoupon(false)}
                                    aria-labelledby="example-custom-modal-styling-title"
                                    centered
                                >
                                    <div className='mt-2 text-center p-1'>
                                        <h4 className='fw-bold'>  Cupón </h4>
                                    </div>
                                    <Modal.Body>
                                        <div className="input-group input-group-lg">
                                            <input type="number" className="form-control" placeholder='Ingrese el monto del cupon $0.00' onChange={(e) => (setInputValueCoupon(e.target.value))} />
                                        </div>

                                        <div className='d-flex justify-content-between mt-3'>
                                            <button className='btn btn-danger btn-lg' onClick={() => setModalCoupon(false)}> Cancelar </button>
                                            <button className='btn btn-success btn-lg' onClick={() => calculateCupon()} > Aplicar  </button>
                                        </div>
                                    </Modal.Body>
                                </Modal>
                            </div>

                            <div className=' d-flex justify-content-between mt-2'>
                                <span className='text-primary fw-semibold'> Información</span>
                            </div>

                            <div className="d-flex justify-content-start align-items-center gap-2 flex-wrap">

                                <div className='border rounded-3 p-1'>
                                    <small className='text-muted opacity-50'> {orderData.order_type === "devolution" ? "Orden de Referencia" : "Notificador"} </small>
                                    <span className="text-dark h5 fw-bold d-block"># {orderData.order_type === "devolution" && orderData.devolution_order_reference !== undefined ? orderData.devolution_order_reference.code : orderData.order_type === "devolution" && orderData.devolution_order_reference !== undefined ? "No tiene referencia" : orderData.locator ? orderData.locator : 0}</span>
                                </div>

                                <div className='border rounded-3 p-1'>
                                    <small className='text-muted opacity-50'> Orden</small>
                                    <span className="text-dark h5 fw-bold d-block">#{orderData.transaction_code ? orderData.transaction_code : 0}</span>
                                </div>
                                {orderData.is_pre_order == true ? <>

                                    <div className='border rounded-3 p-1 h-100'>
                                        <small className='text-muted opacity-50'>  Precuenta </small>
                                        <span className="text-dark h5 fw-bold d-block">
                                            <i class="uil uil-shield-question"></i>
                                            {orderData.is_authorized == false ? 'Se requiere autorizacion' : ''}</span>
                                    </div>

                                </> : <></>}
                                <div className='border rounded-3 p-1 h-100'>
                                    <small className='text-muted opacity-50'> Sucursal </small>
                                    <span className="text-dark h5 fw-bold d-block">
                                        {orderData.branchoffice.name}</span>
                                </div>

                                <div className='border rounded-3 p-1 h-100'>
                                    <small className='text-muted opacity-50'> Usuario </small>
                                    <span className="text-dark h5 fw-bold d-block">
                                        {infoMachine.machine_name} / {!orderData.user ? 'No es cajera' : orderData.user.name}

                                    </span>
                                </div>

                                <div className='border rounded-3 p-1 h-100'>
                                    <small className='text-muted opacity-50'>    Máquina </small>
                                    <span className="text-dark h5 fw-bold d-block">
                                        {infoMachine.code}
                                    </span>
                                </div>
                            </div>

                            {orderData.is_scheduled && (
                                <>
                                    <RenderIf isTrue={orderData.order_type === "delivery"}>
                                        <div className=' d-flex justify-content-between mt-2'>
                                            <span className='text-primary fw-semibold'> Tipo de orden: Delivery (Programado)</span>
                                            <small className="text-dark h5 fw-bold d-block"></small>

                                        </div>
                                    </RenderIf>

                                    <RenderIf isTrue={orderData.order_type === "pickngo"}>
                                        <div className=' d-flex justify-content-between mt-2'>
                                            <span className='text-primary fw-semibold'> Tipo de orden: Pick & Go (Programada)</span>
                                            <small className="text-dark h5 fw-bold d-block"></small>

                                        </div>
                                    </RenderIf>



                                    <div className='border rounded-3 p-1 h-100'>
                                        <small className='text-muted opacity-50'>Hora programada</small>
                                        <span className="text-dark h5 fw-bold d-block">
                                            {formatDateTime(orderData.scheduled_for, orderData.scheduled_timezone)}
                                        </span>
                                    </div>

                                    {orderData.scheduled_window?.start && (
                                        <div className='border rounded-3 p-1 h-100'>
                                            <small className='text-muted opacity-50'>Ventana de recogida</small>
                                            <span className="text-dark h5 fw-bold d-block">
                                                {formatDateTime(orderData.scheduled_window.start, orderData.scheduled_timezone)} - {formatDateTime(orderData.scheduled_window.end, orderData.scheduled_timezone)}
                                            </span>
                                        </div>
                                    )}
                                </>
                            )}
                            <div className=' d-flex justify-content-between mt-2'>
                                <span className='text-primary fw-semibold'> Metodo de pago:</span>
                            </div>

                            <div className="d-flex justify-content-start align-items-center gap-2 flex-wrap">

                                <div className='border rounded-3 w-100 p-1'>
                                    <small className='text-muted opacity-50'> Metodo de pago</small>
                                    <span className="text-dark h5 fw-bold d-block">{orderData.paymenthod}: ${parseFloat(orderData.total).toFixed(2)}</span>
                                </div>

                                {orderData.paymethods ? <>
                                    <RenderIf isTrue={orderData.paymethods.length > 0}>
                                        <div className='border rounded-3 w-100 p-1'>
                                            <small className='text-muted opacity-50'>metodos de pago mixto</small>
                                            <div className="d-flex justify-content-start align-items-center gap-2 flex-wrap">
                                                {orderData.paymethods.map((data) => (<>
                                                    <div className='border rounded-3 p-1'>
                                                        <small className='text-muted opacity-50'> {data.name}</small>
                                                        <span className="text-dark h5 fw-bold d-block">{data.name}: ${parseFloat(data.total).toFixed(2)}</span>
                                                    </div>
                                                </>))}
                                            </div>
                                        </div>
                                    </RenderIf></> : <></>}
                            </div>

                            <div className=' d-flex justify-content-between mt-2'>
                                <span className='text-primary fw-semibold'> Datos del cliente:</span>
                            </div>

                            <div className="d-flex justify-content-start align-items-center gap-2 flex-wrap">

                                <div className='border rounded-3  p-2'>
                                    <small className='text-muted opacity-50'> Nombre:</small>
                                    <span className="text-dark h5 fw-bold d-block">{orderData.client_name}</span>
                                </div>

                                {orderData.client_phone != "" && <div className='border rounded-3 p-2'>
                                    <small className='text-muted opacity-50'> Telefono:</small>
                                    <span className="text-dark h5 fw-bold d-block">{orderData.client_phone}</span>
                                </div>}

                                <div className='border rounded-3 p-2'>
                                    <small className='text-muted opacity-50'> Ruv / dv:</small>
                                    <span className="text-dark h5 fw-bold d-block">Ruc:{orderData.client_ruc} - Dv:{orderData.client_dv}</span>
                                </div>

                                {orderData?.client_address != "" &&
                                    <div className='border rounded-3 p-2'>
                                        <small className='text-muted opacity-50'> Direccion fiscal:</small>
                                        <span className="text-dark h5 fw-bold d-block">{orderData.client_address}</span>
                                    </div>}

                                {orderData?.aditional_info != "" &&
                                    <div className='border rounded-3 p-2'>
                                        <small className='text-muted opacity-50'> Informacion adicional:</small>
                                        <span className="text-dark h5 fw-bold d-block">{orderData.aditional_info}</span>
                                    </div>}

                                {orderData?.table_name != "" &&
                                    <div className='border rounded-3 p-2'>
                                        <small className='text-muted opacity-50'> Nombre de la mesa:</small>
                                        <span className="text-dark h5 fw-bold d-block">{orderData.table_name}</span>
                                    </div>}

                                {orderData?.stand_name != undefined &&
                                    <div className='border rounded-3 p-2'>
                                        <small className='text-muted opacity-50'> Stand:</small>
                                        <span className="text-dark h5 fw-bold d-block">{orderData.stand_name}</span>
                                    </div>}

                                {orderData?.event_name != undefined &&
                                    <div className='border rounded-3 p-2'>
                                        <small className='text-muted opacity-50'> Evento:</small>
                                        <span className="text-dark h5 fw-bold d-block">{orderData.event_name}</span>
                                    </div>}
                            </div>

                            {dataAddress !== null ? <><div className=' d-flex justify-content-between mt-2'>
                                <span className='text-primary fw-semibold'> Direccion de entrega:</span>
                            </div>

                                <div className="d-flex justify-content-start align-items-center gap-2 flex-wrap">

                                    <div className='border rounded-3 w-100 p-1'>
                                        <small className='text-muted opacity-50'> Direccion de entrega</small>
                                        <div className='col-12 col-md-12' >
                                            <label className=" w-100 ">
                                                <span className="plan-details">
                                                    <div className="d-flex justify-content-start">
                                                        <div className='m-2'>
                                                            <span className="plan-type" translate='no'><i class="uil uil-map-marker"></i> Direccion: {dataAddress.name}  <br></br>  <i class="uil uil-house-user"></i> Apto/casa: {dataAddress.house_num}</span>
                                                            <p className="plan-description" translate='no'>Referencia de localizacion: {dataAddress.additional_info} <br></br> Telefono: {dataAddress.phone} <br></br> Latitud: {dataAddress.lat} <br></br> Longitud: {dataAddress.lng}</p>

                                                            <a href={`https://www.google.com/maps/search/?api=1&query=${dataAddress.lat},${dataAddress.lng}`} target="_blank" rel="noopener noreferrer">Ver en Google Maps</a>

                                                            {/*<div className='d-flex justify-content-between align-items-center'>
                                                            {addressNowLocation !== null ? <ModalViewLocation address={{ lat: addressNowLocation.lat, lng: addressNowLocation.lng }}></ModalViewLocation> : <ModalViewLocation Address={{ lat: 0, lng: 0 }}></ModalViewLocation>}

                                                            <Badge className='p-2 m-1' onClick={() => (setShowModalAddress(true), getAddressClientNow())} bg="warning" text="dark">
                                                                <i class="uil uil-edit"> Cambiar direccion</i>
                                                            </Badge>
                                                        </div>*/}
                                                        </div>
                                                    </div>
                                                </span>
                                            </label>
                                        </div >
                                    </div>
                                </div></> : <></>}

                        </div>


                        <RenderIf isTrue={order_type == "temporal" && orderData.is_discount_notification == true}>
                            <div className="">
                                <div className="mt-1 mb-3">

                                    <div className='row d-flex justify-cointent -center alight-item-center m-3'>
                                        <div className="col d-flex justify-cointent-center alight-item-center">
                                            <Button className='' onClick={() => (setModalCoupon(true))}><i className="uil uil-ticket"></i> Aplicar un cupon</Button>
                                        </div>
                                        <div className="col d-flex justify-cointent -center alight-item-center">
                                            <Modalbeneficiary business={business_data} setclient_beneficiary={setclient_beneficiary} setuser_beneficiary={setuser_beneficiary} sethandlerloadData={sethandlerloadData} setbeneficiary={setbeneficiary} getClientsByBusiness={getClientsByBusiness}></Modalbeneficiary>
                                        </div>
                                    </div>

                                    <div className='row d-flex justify-cointent-center alight-item-center m-3'>
                                        {beneficiary != '' ? <><div className="col d-flex justify-cointent-center alight-item-center">
                                            <span className="text-nowrap text-secondary h6 d-block text-center">
                                                <i className="uil uil-chat-bubble-user"></i>
                                                Beneficiario: {beneficiary}
                                            </span>
                                        </div></> : <></>}
                                    </div>
                                    <div className="mb-3 ">
                                        <label htmlFor="">Seleccione el descuento</label>
                                        <select className='form-select mt-2' onChange={e => calculateDiscounts(e.target.value === "Seleccione..." ? 0 : e.target.value)} name="" id="">
                                            <option value={null}>Seleccione...</option>
                                            {discountsOptions()}
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </RenderIf>
                        {(orderDetailGroups.length + orderDetailCombos.length) > 0 ? <>
                            <div className=' d-flex justify-content-between mt-1'>
                                <span className='text-primary fw-semibold'> Productos </span>
                            </div>
                            <div className="branch-wrapper rounded-3 p-1 pt-0 no-scroll">
                                {/* Item cards */}
                                {orderItems()}
                                {orderCombos()}
                                {/**Total details */}
                            </div></> : <></>}


                        <div className='rounded-3 mt-2'>
                            <div className="d-flex justify-content-end mt-1">
                                <span className="text-muted opacity-50 h6"> Descuento: </span>
                                <span className='text-black fw-bold h6'>
                                    <span className="ps-1" translate='no'>$</span>{orderDetailDiscountTotal.toFixed(2)}
                                </span>
                            </div>

                            {/** We render the totals if the order is type permanent */}
                            <RenderIf isTrue={order_type === "permanent"}>
                                <div className="d-flex justify-content-end mt-1">
                                    <span className="text-muted opacity-50 h6"> Subtotal: </span>
                                    <span className='text-black fw-bold  h6'>
                                        <span className='ps1 ' translate='no'>$</span>
                                        {orderData.subtotal.toFixed(2)}
                                    </span>
                                </div>

                                <RenderIf isTrue={orderData.delivery}>
                                    <div className="d-flex justify-content-end mt-1">
                                        <span className="text-muted opacity-50 h6"> Envío: </span>
                                        <span className='text-black fw-bold h6'>
                                            <span className='ps-1' translate='no'>$</span>
                                            {orderData.delivery.value ? orderData.delivery.value.toFixed(2) : "0.00"}
                                        </span>
                                    </div>
                                </RenderIf>



                                {groupedTaxes.map((tax) => (
                                    <>
                                        <div className="d-flex justify-content-end mt-1">
                                            <span className="text-muted opacity-50 h6"> Impuesto {tax.tax}: </span>
                                            <span className='text-black fw-bold h6'>
                                                <span classNme='ps-1' translate='no'>$</span>
                                                {tax.total.toFixed(2)}
                                            </span>
                                        </div></>
                                ))}

                                <div className="d-flex justify-content-end mt-3">
                                    <strong className="text-black h5"> Total: </strong>
                                    <span className='text-black fw-bold h5'>
                                        <span className='ps-1 ' translate='no'>$ </span>
                                        {orderData.total.toFixed(2)}
                                    </span>
                                </div>

                                {orderData.tips && orderData.tips > 0 ? <>
                                    <div className="d-flex justify-content-end mt-1">
                                        <span className="text-gray-dark fw-light h6"> Propina: </span>
                                        <span className='text-black fw-bold h6'>
                                            <span className='ps-1' translate='no'>$</span>
                                            {orderData.tips.toFixed(2)}
                                        </span>
                                    </div></> : <></>}
                            </RenderIf>
                        </div>
                        <div className="">


                            <div className="d-flex text-muted">
                                <div className="pb-3 mb-0 w-100">

                                    {orderData.discounts.length > 0 ? <>
                                        <div className='d-flex justify-content-center alight-item-center m-2' >
                                            <details close >
                                                <summary className=''>
                                                    <span className='badge bg-light text-dark summary-text-pos  fw-bold border rounded-4  text-wrap '>
                                                        <i className="uil uil-info-circle  px-1 "></i>  Detalles del descuento
                                                    </span>
                                                </summary>
                                                {orderData.discounts.map(data => (
                                                    <span className="badge bg-light text-dark  summary-text-pos m-2 border rounded-4 my-1 text-wrap ">
                                                        {/* <span className='kiosk-subtitle-s' >   </span> */}
                                                        <div>
                                                            <div className='text-muted m-0 p-0 h6'> Aprobado por: <strong>{data.aprrovedby ? data.aprrovedby.user_name : ""}</strong></div>
                                                            <div className='text-muted m-0 p-0 h6'>Beneficiario:<strong>{data.beneficiary ? data.beneficiary.user_name != "" ? <>Colaborador - {data.beneficiary.user_name} </> : <> {data.beneficiary.client_name != "" ? <>{data.beneficiary.client_name}</> : <>Consumidor final</>} </> : ""}</strong></div>
                                                            <br /></div>

                                                        <span className='me-2 '> Tipo descuento: <strong>{data.name}</strong> </span>
                                                        <span className='me-2 '> Procentaje: <strong>{data.percentage}</strong> </span>
                                                        <span className='me-2 '> Monto: <strong>{data.total}</strong> </span>

                                                    </span>
                                                ))}
                                            </details>
                                        </div>
                                    </> : <></>}

                                </div>
                            </div>

                            {/** We render the buttons if the order is type temporal */}
                            <RenderIf isTrue={order_type === "temporal"}>
                                <div className='d-flex mt-4 justify-content-between flex-wrap gap-2'>

                                    {orderData.is_pre_order == true ? <>

                                        <Button variant="danger" className='btn col-5' onClick={deletePreOrder} >
                                            Eliminar Precuenta
                                        </Button>
                                        <Button variant="success" className='btn col-5' onClick={updatePreOrder} >
                                            Autorizar Precuenta
                                        </Button>

                                    </> : <>
                                        <Button variant="danger" onClick={cancelOrderDisocunt} className='btn col-5' >
                                            Cancelar
                                        </Button>
                                        <Button variant="success" onClick={updateOrderDiscount} className='btn col-5' >
                                            {orderData.is_discount_notification === true ? "Aprobar descuento" : "Aprobar devolución"}
                                        </Button>
                                    </>}
                                </div>
                            </RenderIf>
                        </div>
                    </div>
                </div>
            </div >

            <ModalimgZoom showModalimgZoom={showModalimgZoom} setShowModalimgZoom={setShowModalimgZoom} img={imgpreview}></ModalimgZoom>
        </ >
    );
}

export default OrderDetails;
